/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

:host {
  inset: 0 !important;
  margin: auto;
  height: fit-content;
  --gap: var(--nve-ref-space-sm);
}

[internal-host] {
  gap: var(--gap);
  display: flex;
  flex-direction: column;
  align-items: center;
}

[internal-host] {
  outline: 0;
}

:host::backdrop {
  /* not available on top layer */
  background: hsl(0 0% 0% / 0.5); /* eslint-disable-line @nvidia-elements/lint/no-unexpected-css-value */
}
